import { jsx as u } from "react/jsx-runtime";
import e from "../utils/cx.js";
const i = ({ children: o, visibled: t, id: a }) => /* @__PURE__ */ u("div", { id: a, className: e("uizz-layout-h-0 uizz-layout-overflow-hidden", { "!uizz-layout-h-auto": t }), children: o });
export {
  i as default
};
//# sourceMappingURL=index.js.map
